import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=2d4d6410"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=2d4d6410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports